import { render, staticRenderFns } from "./size-to-fit.vue?vue&type=template&id=4c5318a7&scoped=true&"
import script from "./size-to-fit.vue?vue&type=script&lang=js&"
export * from "./size-to-fit.vue?vue&type=script&lang=js&"
import style0 from "./size-to-fit.less?vue&type=style&index=0&id=4c5318a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5318a7",
  null
  
)

export default component.exports